/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6e2844d1&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=6e2844d1&scoped=true&lang=less"

import exportComponent from "D:\\work\\官网\\songjia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2844d1"]])

export default __exports__